export const TIME_BUTTON_DOWN = 200;//time is in milliseconds
export const TOTAL_QUESTIONS = 40;
export const STORAGE_PREFIX = 'https://pathology-wsi.s3.amazonaws.com/lung';
export const POSSIBLE_ANSWERS = ['ADCA', 'SCC'];
